import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import { TestButtonLink } from "./TestButtonLink";
import { TestInput } from "./TestInput";

export const TestGeneralActions = () => (
  <div>
    <TestButton url={`${siteLocationPrefix}/test/resetUser`} title="Reset User" />
    <TestButtonLink
      title="Client form responses"
      url={`${siteLocationPrefix}/test/console/clientforms`}
      type={Programs.IdXbox}
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setUserOverride`}
      label="User email override ('delete' to remove) "
      buttonText="change"
      actionName="emailOverride"
    />
    <br />
    <br />
  </div>
);
